module.exports = __webpack_public_path__ + "img/NewsCenterDetails3_pic6.9347c13a.png";